<script>
  import options from './NotificationList.options'
  export default options
</script>

<template>
  <article class="kb-notification-list">
    <div class="kb-gruppeadgangsanmodning-list__header">
      <h2 class="kb-gruppeadgangsanmodning-list__title">{{ getLabel('title') }}</h2>
      <span v-if="notifications.length > 0" class="kb-notification-list__count">{{ totalNumberOfNotifications }} {{ getLabel('resultCountTitle') }}</span>
    </div>
    <ul class="kb-notification-list__items" aria-label="Notifikationer">
      <li class="kb-notification-list__items-item" v-for="notification, index in notifications" :key="index">
        <a :href="notification.link" :aria-labelledby="notification.id" class="kb-notification-list__items-item-card">
          <div>
            <time class="kb-notification-list__items-item-date">{{ notification.date }}</time>
            <p class="kb-notification-list__items-item-text"> {{ notification.text }}</p>
          </div>
        </a>
      </li>
    </ul>

    <div class="kb-general-search__more-results" v-if="notifications.length > 0">
        <span class="kb-general-search__more-results__text">{{ getLabel('resultOutForTitle', [notifications.length, totalNumberOfNotifications]) }}</span>
        <template v-if="totalNumberOfNotifications > notifications.length">
          <button v-on:click="getMoreNotifications" class="kb-button kb-button--full-color">
            {{getLabel('showMoreButtonText')}}
          </button>
        </template>
      </div>

      <template v-if="!totalNumberOfNotifications && !showSpinner && notifications.length === 0">
        <div class="kb-general-search__no-results">
          <h2>{{ getLabel('noResultTitle') }}</h2>
          <p class="kb-general-search__no-results__summary">
            {{ getLabel('noResultDesc') }}
          </p>
          <a
            :href="getLabel('noResultButtonHref')"
            class="kb-button kb-button--full-color-spot"
            >{{ getLabel('noResultButtonText') }}</a
          >
        </div>
      </template>

      <div v-if="showSpinner" class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner"></div>
      </div>
    </article>
</template>
